export default "__VITE_ASSET__04a1104b__"